// src/components/RegistrationForms/FranchiseForm.jsx
import React, { useState } from "react";
import '../Forms.css';


const FranchiseForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    district: "",
    taluka: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Franchise form submitted successfully!");
    setForm({ name: "", email: "", phone: "", district: "", taluka: "" });
  };

  return (
    <section className="form-section" id="franchise">
      <h2>Become a Franchise Partner</h2>
      <form onSubmit={handleSubmit} className="form-container">
        <input
          name="name"
          type="text"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Email ID"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          name="phone"
          type="tel"
          placeholder="Mobile Number"
          value={form.phone}
          onChange={handleChange}
          required
        />
        <input
          name="district"
          type="text"
          placeholder="District"
          value={form.district}
          onChange={handleChange}
          required
        />
        <input
          name="taluka"
          type="text"
          placeholder="Taluka"
          value={form.taluka}
          onChange={handleChange}
          required
        />
        <button type="submit" className="submit-btn">Register</button>
      </form>
    </section>
  );
};

export default FranchiseForm;
